import React, { useEffect, useRef } from "react";
import { Box, Typography } from "@mui/material";
import Splide from "@splidejs/splide";
import "@splidejs/splide/dist/css/splide.min.css";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import image1 from "./assets/image1.png";
import image2 from "./assets/image2.png";
import image3 from "./assets/image3.png";
import image4 from "./assets/image4.png";
import image5 from "./assets/image5.png";
import image6 from "./assets/image6.png";
import image7 from "./assets/image7.png";
import image8 from "./assets/image4.png";
import image9 from "./assets/image8.png";
import image10 from "./assets/image9.png";
import image11 from "./assets/image10.png";
import image12 from "./assets/image11.png";
import Underframe from "./assets/bg3.png";

const iconsTop = [image1, image2, image3, image4, image5, image6];
const iconsBottom = [image7, image8, image9, image10, image11, image12];

// Duplicate the icons to ensure a smoother infinite scroll effect
const duplicatedIconsTop = [...iconsTop, ...iconsTop, ...iconsTop];
const duplicatedIconsBottom = [...iconsBottom, ...iconsBottom, ...iconsBottom];

const LogoCarousel = () => {
  const topSliderRef = useRef(null);
  const bottomSliderRef = useRef(null);

  useEffect(() => {
    // Only initialize if elements are available
    if (
      document.getElementById("logoSliderTop") &&
      document.getElementById("logoSliderBottom")
    ) {
      // Initialize top slider with NEGATIVE speed (right to left)
      topSliderRef.current = new Splide("#logoSliderTop", {
        type: "loop",
        drag: false,
        perPage: 6,
        perMove: 1,
        gap: "2vw",
        pagination: false,
        arrows: false,
        autoplay: false,
        speed: 0,
        easing: "linear",
        autoScroll: {
          speed: 0.5, // Positive speed - moves RIGHT TO LEFT
          autoStart: true,
          pauseOnHover: false, // Disable pause for more consistent motion
          pauseOnFocus: false, // Disable pause for more consistent motion
        },
      });

      // Initialize bottom slider with POSITIVE speed (left to right)
      bottomSliderRef.current = new Splide("#logoSliderBottom", {
        type: "loop",
        drag: false,
        perPage: 6,
        perMove: 1,
        gap: "2vw",
        pagination: false,
        arrows: false,
        autoplay: false,
        speed: 0,
        easing: "linear",
        autoScroll: {
          speed: -0.5, // Negative speed - moves LEFT TO RIGHT
          autoStart: true,
          pauseOnHover: false, // Disable pause for more consistent motion
          pauseOnFocus: false, // Disable pause for more consistent motion
        },
      });

      // Mount the sliders with AutoScroll extension
      topSliderRef.current.mount({ AutoScroll });
      bottomSliderRef.current.mount({ AutoScroll });
    }

    // Cleanup function
    return () => {
      if (topSliderRef.current && topSliderRef.current.destroy) {
        topSliderRef.current.destroy();
      }
      if (bottomSliderRef.current && bottomSliderRef.current.destroy) {
        bottomSliderRef.current.destroy();
      }
    };
  }, []);

  return (
    <Box
      sx={{
        background: "null",
        color: "white",
        textAlign: "center",
        p: { xs: 2, sm: 0 },
        borderRadius: { xs: "12px", sm: "16px", md: "20px" },
        maxWidth: "100%",
        margin: "10px auto",
        overflow: "hidden", // Prevent horizontal scrollbar
        // backgroundImage: `url(${Underframe})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        justifyContent: "center",
      }}
    >
      <Box
        id="logoSliderTop"
        className="splide"
        sx={{
          overflow: "hidden",
        }}
      >
        <div className="splide__track">
          <ul className="splide__list">
            {duplicatedIconsTop.map((icon, index) => (
              <li
                className="splide__slide"
                key={`top-${index}`}
                style={{
                  width: "auto",
                  maxWidth: "80px",
                }}
              >
                <img
                  src={icon}
                  alt={`icon-${index}`}
                  style={{
                    width: "100%",
                    height: "auto",
                    display: "block",
                    margin: "0",
                  }}
                />
              </li>
            ))}
          </ul>
        </div>
      </Box>
      <Box
        id="logoSliderBottom"
        className="splide"
        sx={{
          overflow: "hidden",
        }}
      >
        <div className="splide__track">
          <ul className="splide__list">
            {duplicatedIconsBottom.map((icon, index) => (
              <li
                className="splide__slide"
                key={`bottom-${index}`}
                style={{
                  width: "auto",
                  maxWidth: "80px",
                }}
              >
                <img
                  src={icon}
                  alt={`icon-${index}`}
                  style={{
                    width: "100%",
                    height: "auto",
                    display: "block",
                    margin: "0 auto",
                  }}
                />
              </li>
            ))}
          </ul>
        </div>
      </Box>

      <style jsx global>{`
        .splide__track {
          overflow: visible;
        }
      `}</style>
    </Box>
  );
};

export default LogoCarousel;
